'use client';

import {
  NonSegmentEvents,
  buildEventProperties,
  trackD2CNonSegmentAnalytics,
} from '@/analytics';
import { useAuthorizedCustomerSession } from '@/hooks/authorized-operations';
import { useProductOffer } from '@soluto-private/asp-react-core';
import { useSearchParams } from 'next/navigation';
import { MouseEvent, ReactNode } from 'react';
import styled from 'styled-components';

const StyledLink = styled.a<{ color?: string }>`
  color: ${({ color }) => color || 'initial'};
`;

export const ExternalLink = ({
  path,
  href,
  children,
  ...rest
}: {
  path?: string;
  children?: ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const searchParams = useSearchParams();

  const { customerSession } = useAuthorizedCustomerSession();

  const [{ data: productOffer }] = useProductOffer({
    productOfferId: searchParams.get('poid') as string,
    required: false,
  });

  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    trackD2CNonSegmentAnalytics(
      NonSegmentEvents.ExternalLinkClicked,
      buildEventProperties({
        event: NonSegmentEvents.ExternalLinkClicked,
        customerSession,
        productOffer,
        extraData: {
          LinkTarget: href,
          LinkText: children as string,
        },
      }),
    );
    rest.onClick?.(event);
  };

  return (
    <StyledLink
      href={path ? `${window.location.origin}${path}` : href}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
      onClick={customerSession ? onClick : undefined}
    >
      {children || href}
    </StyledLink>
  );
};
